import styled from "styled-components";
import HeadingForm from "./headings/HeadingForm";

const InputFormHeaderVariant2 = styled(HeadingForm)`
  background-color: ${p => p.theme.color.primaryVariant2};
`;

export default InputFormHeaderVariant2;
